export { renderSwatchPicker_unstable as renderSwatchPicker } from '@fluentui/react-swatch-picker';
